import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { Col, Row } from 'react-grid-system';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../../../atoms/PageTitle';
import PhotoUploader from '../../../../atoms/PhotoUploader';
import Layout from '../../../../templates/Layout';
import Panel from '../../../../atoms/Panel';
const UploadPhotosView = () => {
    const { t } = useTranslation();
    return (_jsxs(Layout, { children: [_jsx(Helmet, { children: _jsx("title", { children: t('copyright_checker.upload.title') }) }), _jsx(PageTitle, { title: t('copyright_checker.upload.title') }), _jsxs(Row, { children: [_jsx(Col, { children: _jsx(Panel, { children: _jsx(PhotoUploader, {}) }) }), _jsx(Col, {})] })] }));
};
export default UploadPhotosView;
